import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faSync,
} from "@fortawesome/free-solid-svg-icons";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const componentStack = errorInfo?.componentStack || "(no component stack)";
    console.error("🔥 [ErrorBoundary] Caught error:", error);
    console.error("🔥 [ErrorBoundary] Component stack:", componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#f8fafc",
            color: "#1e293b",
            fontFamily: "sans-serif",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ fontSize: "48px", color: "#ef4444", marginBottom: "16px" }}
          />
          <h2
            style={{ fontSize: "24px", marginBottom: "8px", fontWeight: "600" }}
          >
            Something went wrong
          </h2>
          <p
            style={{
              color: "#64748b",
              marginBottom: "24px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            The application encountered an unexpected error. We've logged this
            issue.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "10px 20px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <FontAwesomeIcon icon={faSync} />
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
